import React from "react";
import { Button, Result } from "antd";
import { formatPackageBookingRemainingTime } from "../../../common/util/packageBookingExpiration";

export interface IPackageBookingTimerProps {
  remainingSeconds: number;
}

export const PackageBookingTimer: React.FC<IPackageBookingTimerProps> = ({
  remainingSeconds,
}) => (
  <div
    aria-live="polite"
    className="package-booking-expiration-timer"
    role="status"
  >
    Ολοκληρώστε την κράτηση μέσα σε{" "}
    <span>{formatPackageBookingRemainingTime(remainingSeconds)}</span>
  </div>
);

export const PackageBookingExpired: React.FC = () => (
  <div className="package-booking-expired">
    <Result
      status="warning"
      title={<h1>Η κράτησή σας έληξε</h1>}
      subTitle="Το χρονικό όριο των 30 λεπτών ολοκληρώθηκε. Επιλέξτε ξανά το πακέτο σας για να δημιουργήσετε νέα κράτηση."
      extra={
        <Button href="/packages" type="primary">
          Επιστροφή στα πακέτα
        </Button>
      }
    />
  </div>
);

export const PackageBookingUnavailable: React.FC = () => (
  <div className="package-booking-expired">
    <Result
      status="warning"
      title={<h1>Η κράτηση δεν είναι διαθέσιμη</h1>}
      subTitle="Η κράτηση μπορεί να έχει λήξει ή να μην υπάρχει πλέον. Επιλέξτε ξανά το πακέτο σας για να δημιουργήσετε νέα κράτηση."
      extra={
        <Button href="/packages" type="primary">
          Επιστροφή στα πακέτα
        </Button>
      }
    />
  </div>
);
